export const COORDINATOR_SELECTION_MODES = {
  COMPANY_ONLY: 'COMPANY_ONLY',
  COMPANY_WITH_CLIENT: 'COMPANY_WITH_CLIENT',
};

export const COORDINATOR_COMPANY_TYPE_FILTERS = {
  BOTH: 'BOTH',
  COMPANY: 'COMPANY',
  AGENCY: 'AGENCY',
};

export const DEFAULT_COORDINATOR_LABELS = {
  sectionHeading: "Coordinator's Information",
  companyLabel: 'Company / Agency',
  clientLabel: 'Client',
  contactNameLabel: 'Contact name',
  contactEmailLabel: 'Contact email',
  contactMobileLabel: 'Contact mobile',
};

/** Merge saved coordinator settings with defaults. */
export function resolveCoordinatorSettings(settings) {
  const raw = settings?.coordinator && typeof settings.coordinator === 'object'
    ? settings.coordinator
    : {};
  const labelsRaw = raw.labels && typeof raw.labels === 'object' ? raw.labels : {};
  const pickLabel = (key, fallback) => {
    const v = String(labelsRaw[key] ?? '').trim();
    return v || fallback;
  };
  const mode = String(raw.selectionMode || COORDINATOR_SELECTION_MODES.COMPANY_ONLY).toUpperCase();
  const selectionMode = mode === COORDINATOR_SELECTION_MODES.COMPANY_WITH_CLIENT
    ? COORDINATOR_SELECTION_MODES.COMPANY_WITH_CLIENT
    : COORDINATOR_SELECTION_MODES.COMPANY_ONLY;
  const allowedRaw = String(raw.allowedCompanyTypes || COORDINATOR_COMPANY_TYPE_FILTERS.BOTH).toUpperCase();
  const allowedCompanyTypes = Object.values(COORDINATOR_COMPANY_TYPE_FILTERS).includes(allowedRaw)
    ? allowedRaw
    : COORDINATOR_COMPANY_TYPE_FILTERS.BOTH;
  const requireClient = selectionMode === COORDINATOR_SELECTION_MODES.COMPANY_WITH_CLIENT
    ? (raw.requireClient !== undefined ? Boolean(raw.requireClient) : true)
    : false;
  return {
    selectionMode,
    allowedCompanyTypes,
    requireClient,
    labels: {
      sectionHeading: pickLabel('sectionHeading', DEFAULT_COORDINATOR_LABELS.sectionHeading),
      companyLabel: pickLabel('companyLabel', DEFAULT_COORDINATOR_LABELS.companyLabel),
      clientLabel: pickLabel('clientLabel', DEFAULT_COORDINATOR_LABELS.clientLabel),
      contactNameLabel: pickLabel('contactNameLabel', DEFAULT_COORDINATOR_LABELS.contactNameLabel),
      contactEmailLabel: pickLabel('contactEmailLabel', DEFAULT_COORDINATOR_LABELS.contactEmailLabel),
      contactMobileLabel: pickLabel('contactMobileLabel', DEFAULT_COORDINATOR_LABELS.contactMobileLabel),
    },
  };
}

export function coordinatorNeedsClientSelection(settings) {
  return resolveCoordinatorSettings(settings).selectionMode === COORDINATOR_SELECTION_MODES.COMPANY_WITH_CLIENT;
}

export function coordinatorRequiresClientSelection(settings) {
  const resolved = resolveCoordinatorSettings(settings);
  return resolved.selectionMode === COORDINATOR_SELECTION_MODES.COMPANY_WITH_CLIENT && resolved.requireClient !== false;
}

/** Payload fragment for save API. */
export function buildCoordinatorSettingsPayload(coordinatorForm) {
  const c = coordinatorForm || {};
  const mode = String(c.selectionMode || COORDINATOR_SELECTION_MODES.COMPANY_ONLY).toUpperCase();
  const selectionMode = mode === COORDINATOR_SELECTION_MODES.COMPANY_WITH_CLIENT
    ? COORDINATOR_SELECTION_MODES.COMPANY_WITH_CLIENT
    : COORDINATOR_SELECTION_MODES.COMPANY_ONLY;
  const allowedRaw = String(c.allowedCompanyTypes || COORDINATOR_COMPANY_TYPE_FILTERS.BOTH).toUpperCase();
  const allowedCompanyTypes = Object.values(COORDINATOR_COMPANY_TYPE_FILTERS).includes(allowedRaw)
    ? allowedRaw
    : COORDINATOR_COMPANY_TYPE_FILTERS.BOTH;
  const requireClient = selectionMode === COORDINATOR_SELECTION_MODES.COMPANY_WITH_CLIENT
    ? (c.requireClient !== undefined ? Boolean(c.requireClient) : true)
    : false;
  const labels = c.labels || {};
  const pick = (key, fallback) => String(labels[key] || fallback).trim() || fallback;
  return {
    selectionMode,
    allowedCompanyTypes,
    requireClient,
    labels: {
      sectionHeading: pick('sectionHeading', DEFAULT_COORDINATOR_LABELS.sectionHeading),
      companyLabel: pick('companyLabel', DEFAULT_COORDINATOR_LABELS.companyLabel),
      clientLabel: pick('clientLabel', DEFAULT_COORDINATOR_LABELS.clientLabel),
      contactNameLabel: pick('contactNameLabel', DEFAULT_COORDINATOR_LABELS.contactNameLabel),
      contactEmailLabel: pick('contactEmailLabel', DEFAULT_COORDINATOR_LABELS.contactEmailLabel),
      contactMobileLabel: pick('contactMobileLabel', DEFAULT_COORDINATOR_LABELS.contactMobileLabel),
    },
  };
}
